module.exports = __webpack_public_path__ + "static/media/electrico-ico.c07ce6a4.svg";